import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Catalog from './Catalog';
import PaintSystems from './PaintSystems';
import Campaigns from './Campaigns';
// import Products from '../../Containers/Buy/ProductItemsList';

function Buy(props) {
  const { match } = props;

  return (
    <Switch>
      <Route path={`${match.url}/catalog`} component={Catalog} />
      {/* <Route
        path={`${match.url}/products/:q?/:campaign?`}
        component={Products}
      /> */}
      <Route path={`${match.url}/sales/:q?/:campaign?`} component={Catalog} />
      <Route path={`${match.url}/paint-systems`} component={PaintSystems} />
      <Route path={`${match.url}/campaigns`} component={Campaigns} />
    </Switch>
  );
}

Buy.propTypes = {
  match: PropTypes.object.isRequired, //eslint-disable-line
};

export default Buy;



// WEBPACK FOOTER //
// ./src/Routes/Buy/index.jsx